// Add your custom JS here.

jQuery(function ($) {
    if ($('.home').length != 0) {
      $('.home #wrapper-navbar').addClass('not-scroll');
  
      $(window).scroll(function () {
        var height = 150;
        if ($(window).scrollTop() > height) {
          $('.home #wrapper-navbar').removeClass('not-scroll');
        } else {
          $('.home #wrapper-navbar').addClass('not-scroll');
        }
      });
    }



    $('.list-news .carousel-item:first-child').addClass('active');
});

